import React, {useEffect} from 'react';
import {PcUserPower} from './pc/PcUserPower'; // 注意这里是默认导入
import {MobileUserPower} from './mobile/MobileUserPower'; // 注意这里是默认导入

function UserPower({isMobile, clicked, clickNext, ...props}) { // 接收 isMobile props
    // 确保 clickNext 和 clickPrev props 被传递，如果未提供则使用空函数作为默认值
    const commonProps = {
        ...props,
        clicked,
        clickNext: clickNext || (() => {}),
        clickPrev: props.clickPrev || (() => {})
    };

    useEffect(() => {
        if (clicked) {
            clickNext("");
        }
    }, [clicked]);
    if (isMobile) { // 根据 isMobile props 条件渲染
        return <MobileUserPower {...commonProps} />;
    } else {
        return <PcUserPower {...commonProps} />;
    }
}

export default UserPower;